import axiosInstance from "./axiosInstance";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5100/api";

// Public endpoints (no auth token needed)
export const validateToken = (token) =>
    axios.get(`${BASE_URL}/Invitation/Validate/${token}`);

export const applyAsAgent = (data) =>
    axios.post(`${BASE_URL}/Invitation/Apply`, data);

// Authenticated endpoints
export const generateInvitation = (data) =>
    axiosInstance.post("/Invitation/Generate", data);

export const getMyInvitations = (inviterId) =>
    axiosInstance.get(`/Invitation/GetMyInvitations/${inviterId}`);

export const revokeInvitation = (invitationId) =>
    axiosInstance.put(`/Invitation/Revoke/${invitationId}`);

export const getApplications = () =>
    axiosInstance.get("/Invitation/GetApplications");

export const getApplication = (applicationId) =>
    axiosInstance.get(`/Invitation/GetApplication/${applicationId}`);

export const reviewApplication = (data) =>
    axiosInstance.put("/Invitation/Review", data);

export const approveApplication = (applicationId, approvedBy) =>
    axiosInstance.put(`/Invitation/Approve/${applicationId}?approvedBy=${encodeURIComponent(approvedBy)}`);

export const rejectApplication = (data) =>
    axiosInstance.put("/Invitation/Reject", data);
